<template>
  <div
    class="FullscreenView FullscreenView--isLayer Box-root Box-background--white Flex-flex Flex-alignItems--center Flex-direction--column Flex-justifyContent--center"
  >
    <form novalidate="novalidate" style="width: 100%; height: 100%">
      <div
        class="FullscreenHeader Box-root Box-background--white Box-divider--light-bottom-1 Padding-right--20 Padding-left--8 Padding-vertical--20 Flex-flex Flex-justifyContent--spaceBetween"
        style="flex: 0 0 auto"
      >
        <div class="Box-root Flex-flex Flex-alignItems--center">
          <div
            class="PressableCore PressableCore--cursor--pointer PressableCore--height--medium PressableCore--radius--all PressableCore--width PressableCore--width--auto PressableButton Box-root Flex-inlineFlex"
          >
            <div class="PressableCore-base Box-root">
              <v-btn icon color="black" @click="toggleForm()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <div
              class="PressableCore-overlay PressableCore-overlay--extendBy1 Box-root Box-background--white"
            ></div>
          </div>
          <div
            class="FullscreenHeader-separator Box-root Box-background--gray200 Margin-right--20 Margin-left--8"
          ></div>
          <div>
            <div>
              <span
                class="Text-color--default Text-fontSize--14 Text-fontWeight--medium Text-lineHeight--20 Text-numericSpacing--proportional Text-typeface--base Text-wrap--wrap Text-display--inline"
                ><span>Collect Specimen</span></span
              >
            </div>
            <div>{{ currentCollectionProtocol.title }}</div>
          </div>
        </div>
        <div class="Box-root Flex-flex">
          <div class="Box-root" style="pointer-events: none">
            <div
              class="Box-root Flex-flex Flex-alignItems--center Flex-direction--row Flex-justifyContent--flexStart Flex-wrap--nowrap"
              style="margin-left: -20px; margin-top: -20px"
            >
              <div
                class="Box-root Box-hideIfEmpty Margin-top--20 Margin-left--20"
                style="pointer-events: auto"
              >
                <div class="Box-root Margin-top--4">
                  <div class="Box-root">
                    <button
                      data-db-analytics-name="dashboard_create_payment_feedback_link"
                      type="button"
                      class="UnstyledLink ButtonLink Flex-flex"
                    >
                      <div
                        class="Box-root Flex-flex Flex-alignItems--baseline Flex-direction--row"
                        style="position: relative"
                      >
                        <div
                          class="TextAligner Box-root"
                          style="
                            line-height: 20px;
                            font-size: 14px;
                            flex: 0 0 auto;
                          "
                        ></div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
              <div
                class="Box-root Box-hideIfEmpty Margin-top--20 Margin-left--20"
                style="pointer-events: auto"
              >
                <div class="ButtonGroup Box-root" style="pointer-events: none">
                  <div
                    class="Box-root Flex-flex Flex-alignItems--center Flex-direction--row Flex-justifyContent--flexStart Flex-wrap--nowrap"
                    style="margin-left: -8px; margin-top: -8px"
                  >
                    <div
                      class="Box-root Box-hideIfEmpty Margin-top--8 Margin-left--8"
                      style="pointer-events: auto"
                    >
                      <div
                        class="PressableCore PressableCore--cursor--pointer PressableCore--height--medium PressableCore--radius--all PressableCore--width PressableCore--width--auto PressableButton Button Button--color--white Box-root Flex-inlineFlex"
                        style="background-color: rgb(255, 255, 255)"
                      >
                        <div class="PressableCore-base Box-root">
                          <v-btn small elevation="0"
                            >Submit and create another</v-btn
                          >
                        </div>
                        <div
                          class="PressableCore-overlay PressableCore-overlay--extendBy1 Box-root Box-background--white"
                        ></div>
                      </div>
                    </div>
                    <div
                      class="Box-root Box-hideIfEmpty Margin-top--8 Margin-left--8"
                      style="pointer-events: auto"
                    >
                      <div
                        class="PressableCore PressableCore--cursor--pointer PressableCore--height--medium PressableCore--radius--all PressableCore--width PressableCore--width--auto PressableButton Button Button--color--blue Box-root Flex-inlineFlex"
                        style="background-color: rgb(84, 105, 212)"
                      >
                        <div
                          class="PressableCore-base Box-root"
                          @click="submit()"
                        >
                          <v-btn color="primary" small elevation="0"
                            >Submit</v-btn
                          >
                        </div>
                        <div
                          class="PressableCore-overlay PressableCore-overlay--extendBy1 Box-root Box-background--white"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="FullscreenContent FullscreenContent--scroll Box-root Box-background--white"
        style="flex: 1 1 100%; height: calc(100% - 76px)"
      >
        <div class="FormLayout Box-root Box-background--white">
          <div class="Box-root">
            <div
              class="Box-root"
              style="
                margin-left: auto;
                margin-right: auto;
                width: 500px;
                margin-top: 20px;
                min-height: 500px;
              "
            >
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                v-on:submit.prevent
              >
                <v-radio-group
                  v-if="!hasParticipant"
                  v-model="patientSearchType"
                  row
                  hide-details
                  class="mt-0 pt-0"
                  style="margin-bottom: 6px"
                >
                  <v-radio value="mrn" label="Patient MRN" class="mr-4"></v-radio>
                  <v-radio
                    value="externalSubjectId"
                    label="External Subject ID"
                  ></v-radio>
                </v-radio-group>

                <v-text-field
                  dense
                  v-if="!hasParticipant"
                  :label="patientSearchIdentifierLabel"
                  :rules="[requestData.SelectedPatient != null || '*Required']"
                  filled
                  :hint="
                    'Write the ' +
                    patientSearchIdentifierLabel +
                    ' and hit enter to search for patient. Edit it and hit enter to search again.'
                  "
                  required
                  v-on:keyup.enter="searchPatient()"
                  v-model="patientSearchQuery"
                ></v-text-field>

                <div
                  v-if="!hasParticipant && patientSearchMessage"
                  style="
                    color: #d32f2f;
                    font-size: 12px;
                    margin-top: -12px;
                    margin-bottom: 10px;
                  "
                >
                  {{ patientSearchMessage }}
                </div>

                <div
                  v-if="requestData.SelectedPatient"
                  style="
                    min-height: 60px;
                    border-radius: 5px;
                    border: 2px solid #5469d4;
                    border-left: 5px solid #5469d4;
                    margin-bottom: 10px;
                    padding: 10px 20px;
                  "
                >
                  <div class="h3">
                    {{ requestData.SelectedPatient.firstName }}
                    {{ requestData.SelectedPatient.fatherName }}
                    {{ requestData.SelectedPatient.grandFatherName }}
                  </div>
                  <div class="d-flex">
                    <div>Date of Birth:</div>
                    <div>{{ requestData.SelectedPatient.birthDate }}</div>
                  </div>
                  <div class="d-flex">
                    <div>Gender:</div>
                    <div>
                      {{ requestData.SelectedPatient.gender.title }}
                    </div>
                  </div>
                </div>
                <v-text-field
                  dense
                  label="Sample Id"
                  filled
                  required
                  v-model="requestData.SampleID"
                ></v-text-field>
                <v-select
                  :items="institutionSites"
                  item-text="title"
                  filled
                  clearable
                  return-object
                  v-model="requestData.SelectedInstitutionSite"
                  label="InstitutionSite"
                ></v-select>
                <v-select
                  :items="collectionProtocolEvents"
                  item-text="label"
                  filled
                  clearable
                  @change="eventChanged"
                  return-object
                  v-model="requestData.SelectedCollectionProtocolEvent"
                  label="Event"
                ></v-select>
                <v-autocomplete
                  label="Specimen Type"
                  :items="specimenTypes"
                  :search-input.sync="SearchSpecimenType"
                  return-object
                  filled
                  v-model="requestData.SelectedSpecimenType"
                  item-text="title"
                  :rules="[(v) => !!v || '*Required']"
                  clearable
                ></v-autocomplete>
                <!-- <v-select
                  :items="specimenTypes"
                  item-text="title"
                  filled
                  return-object
                  v-model="requestData.SelectedSpecimenType"
                  :rules="[(v) => !!v || '*Required']"
                  label="SpecimenType"
                ></v-select> -->
                <div class="d-flex">
                  <v-text-field
                    label="Collected Amount"
                    :rules="NoEmptyRule"
                    filled
                    type="number"
                    required
                    v-model="requestData.CollectedAmount"
                  ></v-text-field>
                  <v-autocomplete
                    label="Unit Of Measurement"
                    :items="unitOfMeasurements"
                    :search-input.sync="SearchUnitOfMeasurement"
                    return-object
                    filled
                    class="ml-3"
                    v-model="requestData.SelectedUnitOfMeasurement"
                    item-text="unitSymbol"
                    :rules="[(v) => !!v || '*Required']"
                    clearable
                  ></v-autocomplete>
                  <!-- <v-select
                    :items="unitOfMeasurements"
                    item-text="unitName"
                    filled
                    class="ml-3"
                    return-object
                    v-model="requestData.SelectedUnitOfMeasurement"
                    :rules="[(v) => !!v || '*Required']"
                    label="Unit Of Measurement"
                  ></v-select> -->
                </div>
                <div class="d-flex">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="requestData.CollectedDate"
                        label="Collected Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        :rules="NoEmptyRule"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="requestData.CollectedDate"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-menu
                    ref="menu"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="requestData.CollectedTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        class="ml-3"
                        v-model="requestData.CollectedTime"
                        label="Collected Time"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        :rules="NoEmptyRule"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu2"
                      v-model="requestData.BirthTime"
                      full-width
                      @click:minute="$refs.menu.save(requestData.BirthTime)"
                    ></v-time-picker>
                  </v-menu>
                </div>
              </v-form>
            </div>
          </div>
        </div>
      </div>
    </form>
    <v-dialog v-model="patientSearchDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span>Select Patient</span>
          <v-spacer></v-spacer>
          <span style="font-size: 13px; color: #6b6b6b">
            {{ patientSearchResults.length }} patients match
            {{ patientSearchIdentifierLabel }}
            {{ patientSearchQuery }}
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 400px; overflow-y: auto; padding: 0">
          <v-list dense>
            <v-list-item
              v-for="(row, index) in patientSearchResults"
              :key="index"
              style="cursor: pointer"
              @click="selectPatientResult(row)"
            >
              <v-list-item-action style="min-width: 32px">
                <v-icon v-if="isPatientResultSelected(row)" color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="grey">mdi-circle-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ row.patient.firstName }}
                  {{ row.patient.fatherName }}
                  {{ row.patient.grandFatherName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <div class="d-flex">
                    <div style="margin-right: 16px">
                      {{ patientSearchIdentifierLabel }}:
                      {{ patientRowIdentifier(row) }}
                    </div>
                    <div style="margin-right: 16px">
                      DOB: {{ row.patient.birthDate }}
                    </div>
                    <div>Gender: {{ patientGenderTitle(row.patient) }}</div>
                  </div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="primary" text @click="cancelPatientSelection()"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :disabled="!selectedPatientResult"
            @click="confirmPatientSelection()"
            >Select</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import apiClient from "../../API/apiClient";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {},
  name: "add-collection-protocol-collected-samples",
  props: ["toggleForm", "hasParticipant"],
  created() {
    // console.log("The id is: " + this.$route.params.id);
    this.getInstitutionSites();
    this.getCollectionProtocolEvents();
    this.getAllUnitOfMeasurements();
  },
  data() {
    return {
      valid: false,
      departments: [],
      menu1: false,
      menu2: false,
      SearchSpecimenType: null,
      SearchUnitOfMeasurement: null,
      patientSearchDialog: false,
      patientSearchResults: [],
      selectedPatientResult: null,
      patientSearchMessage: "",
      patientSearchType: "mrn",
      requestData: {
        SelectedInstitutionSite: null,
        InstitutionSiteId: null,
        SelectedCollectionProtocolEvent: null,
        CollectionProtocolEventId: null,
        SelectedPatient: null,
        PatientId: null,
        PatientMRN: "",
        ExternalSubjectID: null,
        SampleID: "",
        SelectedSpecimenType: null,
        SpecimenTypeId: null,
        CollectedAmount: 0,
        RemainingAmount: 0,
        SelectedUnitOfMeasurement: null,
        UnitOfMeasurementId: null,
        CollectedDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        CollectedTime: this.getTodaysTime(),
        // CollectedDate: null,
        // CollectedTime: null,
        InstitutionId: null,
        CollectionProtocolId: null,
        PatientId: null,
        IsSubSample: false,
      },
      institutions: [],
      name: "",
      NoEmptyRule: [(v) => !!v || "*required"],
    };
  },
  methods: {
    ...mapActions([
      "getInstitutionSites",
      "getCollectionProtocolEvents",
      "getAllUnitOfMeasurements",
    ]),
    eventChanged(event) {
      console.log("event", event.label);
      apiClient
        .call(
          "GET",
          `institutions/${this.currentInstitution.id}/collectionProtocols/${this.currentCollectionProtocol.id}/collectionProtocolEvents/${event.id}`,
          null
        )
        .then((response) => {
          console.log(response);
        })
        .catch((err) => console.log(err));
    },
    searchPatient() {
      console.log("searching now...");
      this.patientSearchMessage = "";
      this.patientSearchResults = [];
      this.selectedPatientResult = null;
      if (!this.patientSearchQuery) {
        this.requestData.SelectedPatient = null;
        this.patientSearchMessage =
          "Enter the " + this.patientSearchIdentifierLabel + " and hit enter.";
        return;
      }
      apiClient
        .call("GET", this.patientSearchEndpoint(), null)
        .then((response) => {
          // The MRN endpoint returns [{ mrn, patient }], the patients endpoint
          // returns patients directly. Normalise both to { mrn, patient }.
          const rows = (response || []).map((item) =>
            item && item.patient
              ? { mrn: item.mrn, patient: item.patient }
              : { mrn: null, patient: item }
          );

          if (rows.length === 0) {
            this.requestData.SelectedPatient = null;
            this.patientSearchMessage =
              "No patient found for " +
              this.patientSearchIdentifierLabel +
              " " +
              this.patientSearchQuery +
              ".";
            return;
          }

          // A single match is unambiguous, so skip the picker entirely.
          if (rows.length === 1) {
            console.log(rows[0].patient);
            this.requestData.SelectedPatient = rows[0].patient;
            return;
          }

          console.log(
            "patients matching " + this.patientSearchIdentifierLabel,
            rows.length
          );
          this.patientSearchResults = rows;
          this.patientSearchDialog = true;
        })
        .catch((err) => {
          console.log(err);
          this.requestData.SelectedPatient = null;
          this.patientSearchMessage = "Patient search failed, try again.";
        });
    },
    patientSearchEndpoint() {
      if (this.patientSearchType === "mrn") {
        return (
          "institutions/PatientMRNs?institutionId=" +
          this.currentInstitution.id +
          "&mrn=" +
          this.patientSearchQuery
        );
      }
      return (
        "institutions/" +
        this.currentInstitution.id +
        "/patients?ExternalSubjectID=" +
        this.patientSearchQuery
      );
    },
    patientRowIdentifier(row) {
      if (this.patientSearchType === "mrn") {
        return row.mrn;
      }
      return (
        row.patient.externalSubjectID ||
        row.patient.externalSubjectId ||
        ""
      );
    },
    selectPatientResult(row) {
      this.selectedPatientResult = row;
    },
    isPatientResultSelected(row) {
      return this.selectedPatientResult === row;
    },
    confirmPatientSelection() {
      if (!this.selectedPatientResult) {
        return;
      }
      this.requestData.SelectedPatient = this.selectedPatientResult.patient;
      this.patientSearchDialog = false;
      this.patientSearchResults = [];
      this.selectedPatientResult = null;
    },
    cancelPatientSelection() {
      this.patientSearchDialog = false;
      this.patientSearchResults = [];
      this.selectedPatientResult = null;
    },
    patientGenderTitle(patient) {
      return patient.gender && patient.gender.title ? patient.gender.title : "";
    },
    submit() {
      if (this.$refs.form.validate()) {
        // console.log(this.currentInstitution, this.currentCollectionProtocol);
        this.requestData.InstitutionId = this.currentInstitution.id;
        this.requestData.CollectionProtocolId =
          this.currentCollectionProtocol.id;
        if (!this.hasParticipant) {
          // Can happen when the MRN matches several patients and the picker is cancelled.
          if (!this.requestData.SelectedPatient) {
            this.patientSearchMessage =
              "Search for a patient and select one before submitting.";
            return;
          }
          this.requestData.PatientId = this.requestData.SelectedPatient.id;
        } else {
          this.requestData.PatientId =
            this.currentCollectionProtocolParticipant.patientID;
        }
        // console.log();
        if (this.requestData.SelectedCollectionProtocolEvent) {
          this.requestData.CollectionProtocolEventId =
            this.requestData.SelectedCollectionProtocolEvent.id;
        }

        if (this.requestData.SelectedInstitutionSite) {
          this.requestData.InstitutionSiteId =
            this.requestData.SelectedInstitutionSite.id;
        }

        this.requestData.SpecimenTypeId =
          this.requestData.SelectedSpecimenType.id;
        this.requestData.UnitOfMeasurementId =
          this.requestData.SelectedUnitOfMeasurement.id;
        this.requestData.RemainingAmount = this.requestData.CollectedAmount;
        // return;
        apiClient
          .call(
            "POST",
            "institutions/" +
              this.currentInstitution.id +
              "/collectionProtocols/" +
              this.currentCollectionProtocol.id +
              "/collectedSamples",
            this.requestData
          )
          .then((response) => {
            console.log(response);
            this.$store.dispatch("getCollectionProtocolCollectedSamples");
            this.toggleForm();
          })
          .catch((err) => console.log(err));
      }
    },
    getTodaysTime() {
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes();
      return time;
    },
  },
  watch: {
    patientSearchType() {
      // The typed value means something different now, so drop stale state.
      this.patientSearchMessage = "";
      this.patientSearchResults = [];
      this.selectedPatientResult = null;
      this.requestData.SelectedPatient = null;
    },
    SearchUnitOfMeasurement(val) {
      if (val) {
        if (this.SearchedUnitOfMeasurement != val) {
          this.$store.commit("setUnitOfMeasurements", []);
          console.log("searching...", val);
          apiClient
            .call(
              "GET",
              "institutions/" +
                this.currentInstitution.id +
                "/unitOfMeasurements?SearchTerm=" +
                val,
              null
            )
            .then((response) => {
              this.SearchedUnitOfMeasurement = val;
              this.$store.commit("setUnitOfMeasurements", response);
            })
            .catch((err) => {});
        }
      }
    },
    SearchSpecimenType(val) {
      if (val) {
        if (this.SearchedSpecimenType != val) {
          this.$store.commit("setSpecimenTypes", []);
          console.log("searching...", val);
          apiClient
            .call(
              "GET",
              "institutions/" +
                this.currentInstitution.id +
                "/specimenTypes?SearchTerm=" +
                val,
              null
            )
            .then((response) => {
              this.SearchedSpecimenType = val;
              this.$store.commit("setSpecimenTypes", response);
            })
            .catch((err) => {});
        }
      }
    },
  },
  computed: {
    patientSearchIdentifierLabel() {
      return this.patientSearchType === "mrn"
        ? "Patient MRN"
        : "External Subject ID";
    },
    // The two identifiers live on separate requestData fields so the payload
    // always carries only the one that was actually searched.
    patientSearchQuery: {
      get() {
        return this.patientSearchType === "mrn"
          ? this.requestData.PatientMRN
          : this.requestData.ExternalSubjectID;
      },
      set(val) {
        if (this.patientSearchType === "mrn") {
          this.requestData.PatientMRN = val;
          this.requestData.ExternalSubjectID = null;
        } else {
          this.requestData.ExternalSubjectID = val;
          this.requestData.PatientMRN = null;
        }
      },
    },
    ...mapGetters([
      "currentInstitution",
      "currentCollectionProtocol",
      "institutionSites",
      "collectionProtocolEvents",
      "specimenTypes",
      "unitOfMeasurements",
      "currentCollectionProtocolParticipant",
    ]),
  },
};
</script>
